<template>
    <div class="wrap">
        <div class="paragraph">
            估值价格背离是<common-data name="appShortName_37"/>以其原创多因子估值数据构造的另类因子，数值越大，表明估值提前出现异动而价格暂时还没有反应，在利好条件下，更容易寻找上涨可能性大的股票。
        </div>
        <div class="first">一、策略构建原理</div>
        <div class="paragraph">
            在系统股票池中，运用估值价格背离因子精选估值增长显著但股价尚未充分反应的股票，同时结合扣非净利润/净利润_TTM、BBI买入条件等筛选业绩增长强劲、资金不断流入、买方势力相对较强的股票，获取收益。
        </div>
        <div class="first">二、选择因子组合</div>
        <div class="paragraph">1、估值价格背离（另类因子）：描述股票当前估值上涨，但股价未及时反映；</div>
        <div class="paragraph">2、扣非净利润/净利润_TTM（财务类-财务质量）：描述公司利润主要来自主营业务，盈利质量高，可持续性强；</div>
        <div class="paragraph">3、低换手率（量价类-换手率因子）：描述持仓者惜筹惜售态度较一致；</div>
        <div class="paragraph">4、低振幅（量价类-波动率因子）：描述股票上涨前股价波动平稳。</div>
        <div class="paragraph">5、资金净流入（量价类-资金流向因子）：描述市场资金较为看好；</div>
        <div class="paragraph">6、BBI买入条件（量价类-技术指标）：描述当前股价买方相对卖方力量更强；</div>
        <div class="img_center">
           <BaseBigimg :src="require('./img/图片1.png')"></BaseBigimg>
        </div>
        <div class="paragraph">未引入多因子估值数据做风险控制策略回测结果：</div>
        <div class="img_center">
            <BaseBigimg :src="require('./img/图片2.png')"></BaseBigimg>
        </div>
        <div class="paragraph">引入多因子估值数据做风险控制策略回测结果：</div>
        <div class="img_center">
            <BaseBigimg :src="require('./img/图片3.png')"></BaseBigimg>
        </div>
        <div class="first">三、结论</div>
        <div class="paragraph">
            综上可见，<common-data name="appShortName_37"/>的估值价格背离因子，为用户捕捉估值增长显著但股价尚未充分反应的股票，辅之其他因子挖掘后续上涨空间较大的股票或组合，引入多因子估值数据做风险控制，可显著提升策略的表现，从而帮助用户提前占据领先地位、获取更高收益。
        </div>

    <div style="height:20px"></div>
    <note></note>
    <div style="height:25px"></div>
</div>
</template>
<script>
    import note from '../note.vue'
    export default {
        components:{
            note
        }
    };
</script>
<style scoped src="../common.css"></style>
